<template>
  <div class="app-container">
    <list ref="list">
 
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/operation/price/historical/list";

export default {
  name: "offer",
  mixins: [curdMixins],
  components: {
    list
  },
  methods: {

  },
};
</script>